export default "__VITE_PUBLIC_ASSET__ed61c67c__"